import { isEventRSVPDisabled, getEventRSVPButtonLabel } from '@/features/events/eventMobileHelpers';
import { type DiscoveryEventDetail as RadiousEventDetail } from '@/lib/api/apiTypes';
import { getEventLiveCutoffMs } from '@/features/events/eventFormatting';
export { buildGoogleCalendarURL, getCalendarEventEnd } from '@/features/events/eventDetail/eventCalendar';

export type RsvpSheetMode = 'confirm' | 'manage';

export function isDetailEventFull(
  event: Pick<RadiousEventDetail, 'viewer_rsvp_status' | 'is_rsvp_full' | 'is_at_capacity'>
) {
  return isEventRSVPDisabled(event);
}

export function getDetailEventEffectiveEnd(
  event: Pick<RadiousEventDetail, 'starts_at' | 'ends_at'>
) {
  return getEventLiveCutoffMs(event.starts_at, event.ends_at);
}

export function hasDetailEventEnded(
  event: Pick<RadiousEventDetail, 'starts_at' | 'ends_at'>
) {
  return getDetailEventEffectiveEnd(event) <= Date.now();
}

export function isDetailEventHappeningNow(
  event: Pick<RadiousEventDetail, 'starts_at' | 'ends_at'>
) {
  return new Date(event.starts_at).getTime() <= Date.now() && !hasDetailEventEnded(event);
}

export function getDetailEventHoursUntilStart(
  event: Pick<RadiousEventDetail, 'starts_at'>
) {
  const diffMs = new Date(event.starts_at).getTime() - Date.now();
  if (diffMs <= 0) {
    return 0;
  }

  return Math.max(1, Math.ceil(diffMs / (60 * 60 * 1000)));
}

export function isArchivedEvent(event: Pick<RadiousEventDetail, 'status'>) {
  return event.status === 'archived';
}

export function isCancelledEvent(
  event: Pick<RadiousEventDetail, 'is_cancelled' | 'status'>
) {
  return event.is_cancelled || event.status === 'cancelled';
}

export function isReadOnlyEvent(
  event: Pick<RadiousEventDetail, 'is_cancelled' | 'status' | 'starts_at' | 'ends_at'>
) {
  return isCancelledEvent(event) || isArchivedEvent(event) || hasDetailEventEnded(event);
}

export function formatDistanceMilesLabel(distanceMiles: number) {
  return `${distanceMiles.toFixed(distanceMiles < 10 ? 1 : 0)} mi`;
}

export function getStickyBarLabel(
  event: Pick<
    RadiousEventDetail,
    'viewer_rsvp_status' | 'entry_type' | 'cover_price' | 'cover_notes' | 'is_rsvp_full' | 'is_at_capacity'
  >
) {
  if (event.viewer_rsvp_status === 'going') {
    return getEventRSVPButtonLabel(event);
  }
  if (isDetailEventFull(event)) {
    return getEventRSVPButtonLabel(event);
  }
  return getEventRSVPButtonLabel(event);
}
